<template>
  <base-layout>
    <div id="is-mobile" class="d-block d-md-none"></div>
    <transition name="fade" mode="in-out">
      <router-view />
    </transition>
    <transition name="fade" mode="in-out">
      <loading v-if="!ready || loading"></loading>
    </transition>
    <notifications></notifications>
  </base-layout>
</template>

<script>
import { mapGetters, mapState } from 'vuex'
import {BaseLayout} from '@/components/Layouts'
import Loading from '@/components/GeneralViews/Loading'

export default {
  name: 'app',
  components: {
    BaseLayout,
    Loading
  },
  watch: {
    ready: function () {
      document.title = this.$t('common.site_title')
    }
  },
  computed: {
    ...mapGetters([
      'loading',
      'ready'
    ]),
    ...mapState('form', ['structure'])
  }
}
</script>

<style lang="scss">

  @import url('https://fonts.googleapis.com/css?family=Open+Sans:500,600');

  #is-mobile{
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
  }

  html, body {
    &.inSimulation{
      max-height: 100%;
      height: 100%;
      max-height: 100vh;
      height: 100vh;
      overflow: hidden;
    }
  }

  #app {
    font-family: 'Avenir', Helvetica, Arial, sans-serif;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    text-align: center;
    color: #2c3e50;
  }
  #nav {
    padding: 30px;
    a {
      font-weight: bold;
      color: #2c3e50;
      &.router-link-exact-active {
        color: #42b983;
      }
    }
  }

  .fade-enter-active,
  .fade-leave-active {
    transition: opacity .15s
  }

  .fade-enter,
  .fade-leave-to
    /* .fade-leave-active in <2.1.8 */
  {
    opacity: 0
  }

</style>
